import { createServerFn } from "@tanstack/react-start";
import { getHcaptchaSiteKeyFromEnv } from "@/server/hcaptcha-site-key";

/** Public-only config sourced from Worker `vars` (same runtime as `/api/contact`). */
export const getPublicRuntimeConfigFn = createServerFn({
	method: "GET",
}).handler(async () => ({
	hcaptchaSiteKey: getHcaptchaSiteKeyFromEnv(),
}));
